import * as React from 'react'
import { Services } from './Services'
import { SettingsPage } from '@sales-center/components'
import { AppliedReferralCodeBanner } from '../DiscountCodes/AppliedReferralCodeBanner/AppliedReferralCodeBanner'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'

type ServiceDialogContentProps = {
  address: string
  branchId: string
  entityId: number
  entityType: ENTITY_TYPES
  readOnly?: boolean
  referralDiscountId?: string
  serviceLocations: LocationDTO[]
  serviceLocationsLoading?: boolean
}

export const ServiceDialogContent: React.FC<ServiceDialogContentProps> = (
  props,
) => {
  const {
    readOnly,
    referralDiscountId,
    serviceLocationsLoading = false,
  } = props

  return (
    <SettingsPage
      fullScreen
      headContent={
        referralDiscountId && (
          <AppliedReferralCodeBanner referralDiscountId={referralDiscountId} />
        )
      }
      title={`${readOnly ? 'View' : 'Manage'} Services and Products`}
    >
      <Services
        {...props}
        serviceLocations={props.serviceLocations}
        serviceLocationsLoading={serviceLocationsLoading}
        variant="verbose"
      />
    </SettingsPage>
  )
}
ServiceDialogContent.displayName = 'ServiceDialogContent'
